import { Container, Header, Segment, Grid } from "semantic-ui-react";

export const Title = (props) => {
  return (
    <Segment basic padded="very">
      <Container textAlign="center">
        <Header id="title" size="huge" textAlign="center" sub={false}>
          Panoptic Narrative Grounding Benchmark
          <Header.Subheader size="huge">
            ICCV 2021 Oral Presentation
          </Header.Subheader>
        </Header>
        <Grid columns={1} divided>
          <Grid.Row>
            <Grid.Column textAlign="center">
              <a href="https://cinfonia.uniandes.edu.co" target="_blank">
                <img
                  src={`./LOGO-CINFONIA-NEGRO.png`}
                  height={50}
                  alt="CINFONIA logo"
                />
              </a>
            </Grid.Column>
            {/* <Grid.Column textAlign="left">
              <img
                src={`./logo_google.png`}
                height={50}
                alt="Google research logo"
              />
            </Grid.Column> */}
          </Grid.Row>
        </Grid>
      </Container>
    </Segment>
  );
};
